var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificReserve(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F5EDFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_1260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 28,
    height: 28,
    fill: "#DEA829"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_1260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9968 20.8816C34.9968 21.0379 34.9968 21.1675 34.9968 21.2963C34.9968 25.0006 34.9968 28.7041 34.9968 32.4084C34.9968 34.0312 34.0337 34.9989 32.4192 34.9996C26.807 35.0004 21.1948 35.0004 15.5834 34.9996C13.9712 34.9996 13.0073 34.0296 13.0073 32.4068C13.0066 28.7025 13.0073 24.999 13.0073 21.2947V20.8816H34.9976H34.9968ZM22.4531 28.4472C21.84 27.8212 21.2623 27.2172 20.6666 26.6297C20.3149 26.2833 19.8628 26.2809 19.5441 26.5888C19.2137 26.9077 19.2121 27.3743 19.5708 27.7395C20.322 28.5054 21.0794 29.2649 21.8463 30.015C22.2027 30.3638 22.5943 30.3827 22.9703 30.0622C24.7929 28.5101 26.6092 26.9525 28.4224 25.3894C28.7874 25.0752 28.8235 24.6071 28.544 24.2709C28.2544 23.9222 27.785 23.8947 27.3933 24.2136C27.1092 24.4445 26.8368 24.6896 26.5582 24.9283C25.2089 26.0853 23.8588 27.2416 22.4523 28.4472H22.4531Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0129 19.2571C13.0129 18.4048 12.9792 17.5793 13.0208 16.7585C13.0836 15.5229 14.1016 14.5898 15.3606 14.5725C16.381 14.5584 17.4022 14.5631 18.4226 14.5592C18.4336 14.5592 18.4446 14.5474 18.5042 14.5136C18.5042 14.2992 18.4964 14.0549 18.5058 13.8114C18.5246 13.3315 18.8472 13.0016 19.2876 13C19.7248 12.9984 20.0544 13.3323 20.0741 13.8075C20.0835 14.0415 20.0756 14.2772 20.0756 14.5403H27.9272C27.9272 14.296 27.9193 14.051 27.9287 13.8075C27.9484 13.3291 28.2741 13 28.7144 13C29.1516 13 29.4782 13.3338 29.4978 13.8106C29.5072 14.0447 29.4994 14.2795 29.4994 14.5505C29.6438 14.5576 29.7694 14.5678 29.895 14.5686C30.7984 14.5702 31.7011 14.5623 32.6045 14.5717C33.9726 14.5851 34.9781 15.5881 34.9954 16.9549C35.0048 17.7128 34.9969 18.4716 34.9969 19.2579H13.0129V19.2571Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.453 28.4469C23.8596 27.2412 25.2089 26.085 26.559 24.928C26.8368 24.69 27.11 24.445 27.3941 24.2133C27.7866 23.8936 28.2552 23.9218 28.5448 24.2706C28.8242 24.6068 28.7873 25.0749 28.4231 25.3891C26.6108 26.9522 24.7937 28.5106 22.9711 30.0619C22.5951 30.3823 22.2034 30.3635 21.8471 30.0147C21.0802 29.2646 20.322 28.5059 19.5716 27.7392C19.2129 27.3732 19.2145 26.9074 19.5449 26.5885C19.8636 26.2806 20.3157 26.283 20.6674 26.6294C21.2623 27.2161 21.8408 27.8209 22.4538 28.4469H22.453Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificReserve);
export default __webpack_public_path__ + "static/media/notific_reserve.753b7feb9c05c9b5265353adf40fd330.svg";
export { ForwardRef as ReactComponent };